export default __webpack_public_path__ + "static/media/FI-23.bf152eaf.jpg";